import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import { getRecentlySearch } from '../_util';
import { mergeModules } from '@/store/helpers';
import common from '../../md-search/_store/common';
// import { searchCenter } from './isSearchCenter';
function initState({ searchCenter }) {
    const common = {
        outsideFields: [],
        conditions: {},
        keywords: [],
        recentlySearch: getRecentlySearch(),
        mapCondition: {},
        customizedCity: [],
        searchCharts: [],
        locationPlaceholder: '',
        listingIds: '',
        translatedProps: {}, // for recording search-bar among those select The dropdown list of the box has been translated ， like ：{propertyType: true}
        currencyPriceKeys: [] //  Store the search configuration inside with price related fields ， Need to convert to USD ,  Pass USD when searching 
    };
    const state = {
        // fetcherData moduleMap conditionSort  data redundancy 
        fetcherData: {}, //  data for rendering ， Contains information such as grouping 
        moduleMap: {}, //  reserve  condition  configuration items ， easy to read 
        conditionSort: [], //  for tag sort of 
        searchQueryOnUrl: null,
        hasConditionOnUrl: false,
        locationQueryOnUrl: '',
        urlPresetParams: null,
        mapConditionOnUrl: {
            rect: '',
            mapPath: '',
            mapSearch: false,
            zoom: 14,
            threshold: 10
        }
        // ...common
    };
    const centerState = {
        uiConfig: {},
        // outsideFields: [],
        searchConfigMap: {},
        computedPresetFilter: {},
        urlPresetParams: null,
        conditionOnUrl: {}
        // ...common
    };
    return {
        ...common,
        ...(searchCenter ? centerState : state)
    };
}

const modules = mergeModules(common, {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions
});
export default modules;
